import { Vector, type IVector, VEC2 } from '../math/vector'
import { reactive, getCurrentInstance } from 'vue'
import { v4 } from 'uuid'

export interface IMouseState {
  position: Vector
  delta: IVector
  isDown: boolean
  initialized: boolean
}

export const mouse = reactive({
  position: new Vector(0, 0),
  delta: { x: 0, y: 0, z: 0, w: 0 },
  isDown: false,
  initialized: false
})

export type ClickListener = () => void
type ClickListenerMap = Record<string, ClickListener>
const clickListeners: ClickListenerMap = {}

//export const mouseRef = new Proxy(mouse, {
//  get(target, key, reciever) {
//    return target[key as keyof IMouseState];
//  },
//  set(target, key, newValue, receiver) {
//    const k = key as keyof IMouseState;
//
//    const old = {...target};
//    const next = {...target, [k]: newValue};
//
//    //if (JSON.stringify(old) === JSON.stringify(next)) return false;
//
//    target[k] = newValue;
//
//    return true;
//  }
//});

const setupMouse = () => {
  if (mouse.initialized) return

  mouse.initialized = true

  window.addEventListener('mousemove', (event: MouseEvent) => {
    const x: number = event.clientX
    const y: number = event.clientY
    const dx: number = event.movementX
    const dy: number = event.movementY
    mouse.position.x = x
    mouse.position.y = y
    mouse.delta = { x: dx, y: dy, z: 0, w: 0 }
    // mouseRef.delta = mouse.delta;
    //mouseRef.position = mouse.position;
  })

  window.addEventListener('mousedown', () => {
    mouse.isDown = true
  })

  window.addEventListener('mouseup', () => {
    mouse.isDown = false
  })

  window.addEventListener('click', () => {
    for (const listener of Object.values(clickListeners)) {
      listener()
    }
  })
}

setupMouse()

export interface IUseMouse {
  mouse: IMouseState
  elementIntersects: (el: HTMLElement) => boolean
  cancel: () => void
}

export interface IUseMouseOptions {
  onClick?: () => void
}

const defaultUseMouseOptions: IUseMouseOptions = {}

export const useMouse = (options: IUseMouseOptions = defaultUseMouseOptions): IUseMouse => {
  const componentInstance = getCurrentInstance()
  let uid = v4()

  if (componentInstance) {
    uid = componentInstance.uid.toString()
  }

  if (componentInstance && !clickListeners[uid]) {
    if (options.onClick) clickListeners[uid] = options.onClick
  }

  const elementIntersects = (el: HTMLElement) => {
    const mpos = mouse.position
    const rect = el.getBoundingClientRect()
    const min = new Vector(rect.x, rect.y)
    const max = min.add(VEC2(rect.width, rect.height))
    if (mpos.x < min.x || mpos.x > max.x) return false
    if (mpos.y < min.y || mpos.y > max.y) return false
    return true
  }

  const cancel = () => {
    delete clickListeners[uid]
  }

  return { mouse, elementIntersects, cancel }
}
